import { render, staticRenderFns } from "./SertifikatWebinar.vue?vue&type=template&id=486d1865&"
import script from "./SertifikatWebinar.vue?vue&type=script&lang=js&"
export * from "./SertifikatWebinar.vue?vue&type=script&lang=js&"
import style0 from "./SertifikatWebinar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports